/** @format */

import { Injectable, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "./auth.service";
import idleTimeout from "idle-timeout";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { SessionDialogComponent } from "../Shared/shared/session-dialog/session-dialog.component";

@Injectable({
	providedIn: "root",
})
export class InactivityServiceService {
	// private timeout: any;
	private readonly idleTime = 10 * 60 * 1000; // 10 minutes
	private instance?: ReturnType<typeof idleTimeout>;
	private dfModalRef?: BsModalRef;
	private isProcessing?: boolean = false;

	constructor(
		private readonly router: Router,
		private readonly ngZone: NgZone,
		private readonly bsModalService: BsModalService,
		private readonly authenticationService: AuthService,
	) {}

	startWatching() {
		this.initIdleTimeout();
		// this.resetTimer();
		// this.listenToUserActivity();
	}

	private initIdleTimeout() {
		this.instance = idleTimeout(
			(element, timeout) => {
				console.log(`Idle state detected after ${timeout} ms`);
				if (!this.authenticationService.isLoggedIn || this.isProcessing)
					return;

				this.isProcessing = true;
				this.dfModalRef = this.bsModalService.show(
					SessionDialogComponent,
					{
						initialState: {},
						ignoreBackdropClick: true,
						class: "modal-sm modal-dialog-centered",
					},
				);

				this.dfModalRef?.content?.onExitClicked.subscribe((v) => {
					this.logout();
					this.dfModalRef?.hide();
					this.instance?.reset();
					this.isProcessing = false;
				});

				this.dfModalRef?.content?.onRefreshClicked.subscribe((v) => {
					this.dfModalRef?.hide();
					this.instance?.reset();
					this.isProcessing = false;
				});
			},
			{
				element: document,
				timeout: this.idleTime,
				loop: true,
			},
		);
	}

	// private listenToUserActivity() {
	//   window.addEventListener('mousemove', () => this.resetTimer());
	//   window.addEventListener('keydown', () => this.resetTimer());
	//   window.addEventListener('click', () => this.resetTimer());
	//   window.addEventListener('scroll', () => this.resetTimer());
	// }

	// private resetTimer() {
	//   if (this.timeout) {
	//     clearTimeout(this.timeout);
	//   }

	//   this.timeout = setTimeout(() => {
	//     this.logout();
	//   }, this.idleTime);
	// }

	private logout() {
		this.ngZone.run(() => {
			this.authenticationService.logout(true);
			this.router.navigate(["/auth/login"]);
		});
	}
}
